import { render } from "./ColourGroupForm.vue?vue&type=template&id=058d44bd"
import script from "./ColourGroupForm.vue?vue&type=script&lang=js"
export * from "./ColourGroupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__